module.exports = __webpack_public_path__ + "img/80.a3adf6e7.jpg";